// extracted by mini-css-extract-plugin
module.exports = {"selectedUser":"selectTenant_selectedUser__NjBjf","selectedUserName":"selectTenant_selectedUserName__2_815","avatar":"selectTenant_avatar__2WHcH"};